import styled, { css } from 'styled-components';
import StyledModal from '../Modal/styled';
import COLORS from '../../../constants/COLORS';

export default {
  Wrapper: styled.div<{ withoutImages: boolean }>`
    ${StyledModal.Container} {
      padding: 0;
    }

    ${StyledModal.Overlay} {
      z-index: 25;
    }

    ${StyledModal.Close} {
      opacity: 1;
      z-index: 24;

      padding: 8px;
      top: 8px;
      right: 8px;
      svg {
        width: 12px;
        height: 12px;
      }
    }

    .slick-slide {
      font-size: 0;
    }
  `,

  PrevArrow: styled.button`
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 100%;
    background: transparent;
    outline: none;
    border: 0;
    padding: 0;

    svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      margin: auto;
      z-index: 2;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 32px;
      height: 100%;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0) 100%);
      z-index: 1;
    }
  `,

  NextArrow: styled.button`
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 100%;
    background: transparent;
    outline: none;
    border: 0;
    padding: 0;

    svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      margin: auto;
      z-index: 2;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 32px;
      height: 100%;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.24) 100%);
      z-index: 1;
    }
  `,

  Images: styled.div<{ stretch?: boolean }>`
    display: flex;
    margin-bottom: -8px;
    ${(props) =>
      props.stretch &&
      `
      align-items: stretch;
    `}
  `,

  Image: styled.div<{ src: string; height?: number | string }>`
    height: ${(props) => props.height || '120px'};
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${(props) => props.src});
    background-position: center center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    @media screen and (max-width: 700px) {
      height: 202px;
    }
  `,

  Content: styled.div`
    padding: 24px;
  `,

  Title: styled.div`
    font-size: 20px;
    line-height: 26px;
    font-weight: bold;
    font-size: 24px;
  `,

  Text: styled.div`
    margin-top: 8px;
    font-size: 16px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.64);
    white-space: pre-line;
    font-weight: 500;
    color: rgba(21, 16, 53, 0.4);
  `,

  Footer: styled.div<{ error?: boolean }>`
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${(props) =>
      props.error &&
      css`
        color: #eb5757;
        font-size: 16px;
      `}
  `,

  InfoList: styled.div`
    display: flex;
    align-items: center;
  `,

  Info: styled.div`
    font-size: 16px;
    line-height: 21px;

    &:not(:last-child) {
      ${(props) =>
        props.theme.isRtl
          ? css`
              margin-left: 40px;
            `
          : css`
              margin-right: 40px;
            `}
    }
  `,

  InfoLabel: styled.div`
    margin-bottom: 3px;
    font-size: 12px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.64);
  `,

  Controls: styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.64);

    @media screen and (max-width: 700px) {
      margin-top: 8px;
    }
  `,

  Total: styled.div`
    background: ${COLORS.MARKETPLACE_GREY};
    color: rgba(21, 16, 53, 0.4);
    padding: 10px 32px;

    @media screen and (max-width: 700px) {
      padding: 10px 20px;
    }
  `,
  TotalValue: styled.span<{ black: boolean }>`
    margin: 0 4px;
    color: ${(props) => (props.black ? COLORS.MARKETPLACE_BLACK : COLORS.MARKETPLACE_DARK_GREY)};
  `,
  MarketplaceItemPrice: styled.div`
    color: ${COLORS.MARKETPLACE_BLACK};
    font-weight: 700;
  `,
  MarketplaceAvailable: styled.div`
    color: ${COLORS.MARKETPLACE_DARK_GREY};
  `,
};
